import { Numeric9BoxOutlineIcon } from './Numeric9BoxOutlineIcon';

/**
 * author: Google
 * id EE2E9486-0C32-4EC9-9D4F-9B8A7287F696
 * name numeric-9-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericNineBoxOutlineIcon = Numeric9BoxOutlineIcon;
export default NumericNineBoxOutlineIcon